import React from 'react';
import { Outlet } from 'react-router-dom';

const ProductionReportContent = () => {
  return (
    <div className={`dashboard min-h-screen flex  overflow-x-hidden`}>
      {/* {!hideSideBar && (
        <div className='max-lg:hidden'>
          <Sidebar />
        </div>
      )} */}
      <div className='w-full flex flex-col h-screen'>
        {/* <Header title={backLinkTitle} hideSideBar /> */}
        <div className='p-4 pt-6'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ProductionReportContent;
